<template>
    <a-menu class="towerList"
        mode="inline" :inlineIndent="12"
    >
        <RecycleScroller class="scroller"
            :items="towers" :item-size="32"
            key-field="name" ref="scroller"
        >
            <li slot-scope="{ item }" :key="item.name"
                :class="{ 
                    'ant-menu-item-selected': $route.params.id == item.name 
                }"
                class="ant-menu-item" @click="selectTower(item.name)"
            >{{ item.title }}</li>
        </RecycleScroller>
    </a-menu>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
    props: [ "towers" ],
    methods: {
        selectTower(name) {
            this.$emit("selectTower", name);
        },
        showIndex(index) {
            this.$nextTick(() => {
                const scroller = this.$refs.scroller;
                if (scroller.$_startIndex > index || scroller.$_endIndex < index + 10) {
                    scroller.scrollToItem(Math.max(index - 3));
                }
            })
        },
    },
    components: {
        RecycleScroller
    }
}
</script>

<style lang="less">
.towerList {
    height: 100%;
    border-right: 1px;
    overflow-y: auto;
    .scroller {
        height: 100%;
    }
    .ant-menu-item {
        height: 24px;
        line-height: 24px;
    }
}
</style>